import type { TNAPIQuery } from '~/types/napi-helpers'

function getGradProof(slug: string, isPublic: boolean = true) {
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce(
    '/napis/v1/graduation-proofs/{proof_id_slug}/',
    'get',
    {
      proof_id_slug: slug
    },
    {
      is_public: isPublic
    }
  )
}

async function listGradProofReactive(query: TNAPIQuery<'/napis/v1/graduation-proofs/', 'get'>) {
  const { openApiReactiveGet } = useAuthFetch()
  const response = await openApiReactiveGet(
    '/napis/v1/graduation-proofs/',
    undefined,
    query
  )
  return response
}

type UseGradProofReturnType = {
  getGradProof: typeof getGradProof
  listGradProofReactive: typeof listGradProofReactive
}

export function useGradProof(): UseGradProofReturnType {
  return {
    getGradProof,
    listGradProofReactive
  }
}
